import styled from "@emotion/styled";
import { motion } from "framer-motion";

export const Section = styled(motion.section)(() => ({
  padding: "3rem 0 6rem 0",
  background: "#fff",
}));
